import { render } from "./ReviewView.vue?vue&type=template&id=4fac25e6&scoped=true&ts=true"
import script from "./ReviewView.vue?vue&type=script&lang=ts"
export * from "./ReviewView.vue?vue&type=script&lang=ts"

import "./ReviewView.vue?vue&type=style&index=0&id=4fac25e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fac25e6"]])

export default __exports__